<template>
  <v-container>
    <h2>Products</h2>
    <v-data-table v-if="list" :headers="headers" :items="list">
      <template v-slot:item.name="i">
      <a :href="i.item.url">{{ i.item.name }}</a>
      </template>
    </v-data-table>
    <v-skeleton-loader v-else
      type="table"
    ></v-skeleton-loader>
    <v-btn color="primary" :disabled="nextToken == null" @click="loadList">Load more</v-btn>
    </v-container>
</template>

<script>

  import { mapState } from "vuex";
  import ParseRoute from "@/mixins/parse-route";

  export default {
    name: 'Products',
    mixins: [ParseRoute],
    data() {
      return {
        headers: [
          { text: 'ID', value: 'id' },
          { text: 'Product name', value: 'name' },
          { text: 'Score', value: 'popularity'},
        ]
      };
    },
    computed: {
      ...mapState('products', ['list', 'nextToken']),
    },
    methods: {
      loadList() {
          this.$store.dispatch('products/list', { domainID: this.domain, sortDirection: 'DESC', nextToken: this.nextToken });
      }
    },
    created() {
      if(!this.list) {
      this.loadList();
      }
    }
  }
</script>
